import { render } from "./DemoTopHeader.vue?vue&type=template&id=09a666ac&scoped=true"
import script from "./DemoTopHeader.vue?vue&type=script&lang=js"
export * from "./DemoTopHeader.vue?vue&type=script&lang=js"

import "./DemoTopHeader.vue?vue&type=style&index=0&id=09a666ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a666ac"]])

export default __exports__